export const GLOBAL_BASE_URL = process.env.VUE_APP_API_BASE_URL

//===========================================store function api=========================================

export const EP_USER_LOGIN = `${GLOBAL_BASE_URL}auth-server/oauth/token`
// export const EP_REGISTRATION = `${GLOBAL_BASE_URL}api/customer/register`
export const EP_REGISTRATION = `${GLOBAL_BASE_URL}v2/api/customer/register`
export const EP_DEMO_ACCOUNT = `${GLOBAL_BASE_URL}api/customer/{{customerId}}/account/demo`

export const EP_VERIFY_OTP = `${GLOBAL_BASE_URL}customers/api/customer/verification/email/validate`
export const EP_RESEND_OTP = `${GLOBAL_BASE_URL}customers/api/customer/verification/email/send`
export const EP_USER_FORGOT_PASSWORD = `${GLOBAL_BASE_URL}customers/api/customer/password/forgot`
export const EP_GET_CUSTOMER_DETAILS = `${GLOBAL_BASE_URL}customers/api/customer/details`
export const EP_RESET_PASSWORD_FROM_HASH = `${GLOBAL_BASE_URL}customers/api/customer/password/reset`
export const EP_GET_COUNTRY_LIST = `${GLOBAL_BASE_URL}utils/api/countries?getOnlyEuMmber=false`
export const EP_SEND_SMS_MOBILE = `${GLOBAL_BASE_URL}customers/api/customer/verification/sms/send`
export const EP_VERIFY_MOBILE_OTP = `${GLOBAL_BASE_URL}customers/api/customer/verification/sms/validate`
export const EP_UPLOAD_USER_IMAGE = `${GLOBAL_BASE_URL}customers/api/customer/avatar`
export const EP_PUT_USER_NAME = `${GLOBAL_BASE_URL}customers/api/customer/profile/name` 
export const EP_GET_BROKERS_LIST = `${GLOBAL_BASE_URL}flavors/v2/api/brokers/listForRegistration?all=true`
export const EP_GET_BROKER_CURRENCY_LIST = `${GLOBAL_BASE_URL}users/api/user/registrationFlow/brokers/{{ID}}/listCurrencies`
export const EP_GET_BROKER_SERVER_LIST = `${GLOBAL_BASE_URL}users/api/user/registrationFlow/brokers/{{ID}}/listServers`
export const EP_GET_BROKER_SYMBOL_PATTERN = `${GLOBAL_BASE_URL}users/api/user/registrationFlow/brokers/{{ID}}/listSymbolPatterns`
export const EP_CONNECT_EXISTING_BROKER = `${GLOBAL_BASE_URL}users/v2/api/user/registrationFlow/linkToExistingBrokerAccount?async=true`
export const EP_BROKER_SIGNUP = `${GLOBAL_BASE_URL}customers/api/customer/broker/{{ID}}/signup`
export const EP_GET_USER_BROKER_STATUS_LIST = `${GLOBAL_BASE_URL}customers/api/customer/broker/{{ID}}/status`
export const EP_SAVE_BROKER_PERSONAL_INFO = `${GLOBAL_BASE_URL}customers/api/customer/broker/{{ID}}/personal/information`
export const EP_SAVE_BROKER_FINANCIAL_DETAIL = `${GLOBAL_BASE_URL}customers/api/customer/broker/{{ID}}/financial/information`
export const EP_GET_BROKER_QUESTIONS_LIST = `${GLOBAL_BASE_URL}customers/api/customer/questionnaire`
export const EP_SAVE_BROKER_QUESTIONS = `${GLOBAL_BASE_URL}customers/api/customer/questionnaire/{{ID}}`
export const EP_SAVE_BROKER_TERMS = `${GLOBAL_BASE_URL}customers/api/customer/broker/{{ID}}/user/terms`
export const EP_GET_BROKER_STABILITY_QUESTIONS_LIST = `${GLOBAL_BASE_URL}customers/api/customer/questionnaire?status=PENDING`
export const EP_GET_BROKER_SETTINGS = `${GLOBAL_BASE_URL}customers/api/customer/broker/{{ID}}/settings`
export const EP_SAVE_BROKER_POR_DOCUMENT = `${GLOBAL_BASE_URL}kyc/api/customer/kyc/document`
export const EP_GET_SUM_SUB_TOKEN = `${GLOBAL_BASE_URL}kyc/api/kyc/session`
export const EP_GET_OPEN_TICKET_TOKEN = `${GLOBAL_BASE_URL}customers/api/customer/broker/{{ID}}/token`
export const EP_SAVE_BROKER_ACCOUNT_PREFRENCES = `${GLOBAL_BASE_URL}customers/api/customer/broker/{{ID}}/accounts/settings`
export const EP_GET_BROKER_FUND_TOKEN = `${GLOBAL_BASE_URL}customers/api/customer/broker/{{ID}}/token`
export const EP_GET_BROKER_PLATFORM_LIST = `${GLOBAL_BASE_URL}brokers/api/brokerPlatform/secure?all=true`
export const EP_GET_BROKER_TRADING_ACCOUNTS = `${GLOBAL_BASE_URL}customers/api/customer/broker/{{ID}}/accounts`
export const CONNECT_INTEGRATED_BROKER_EXISTING_ACCOUNT = `${GLOBAL_BASE_URL}customers/api/customer/broker/{{ID}}/existing/accounts/link`
export const EP_GET_SUBSCRIPTION_PLANS = `${GLOBAL_BASE_URL}payments/api/payments/v2/membership/availablePlans`
export const EP_GET_SELECTED_PLAN = `${GLOBAL_BASE_URL}payments/api/customer/planDetails`
export const EP_GET_SELECT_PLAN = `${GLOBAL_BASE_URL}payments/api/customer/membershipPlan`
export const EP_GET_CANCEL_PLAN = `${GLOBAL_BASE_URL}payments/api/customer/membershipPlan`
export const EP_GET_SAVED_CARDS = `${GLOBAL_BASE_URL}payments/api/checkout/customers/instruments`
export const EP_SAVE_CARDS = `${GLOBAL_BASE_URL}payments/api/card/add`
export const EP_INITIATE_PAYMENT = `${GLOBAL_BASE_URL}payments/api/checkout/payments`
export const EP_GET_SAVED_CUST_CHECKOUT = `${GLOBAL_BASE_URL}payments/api/checkout/customers`
export const EP_USER_DETAIL_WITH_ACCOUNTS = `${GLOBAL_BASE_URL}api/customer`
export const EP_BECOME_LEADER = `${GLOBAL_BASE_URL}traders/api/providers/leader`
export const EP_BROKER_RAISE_QUERY = `${GLOBAL_BASE_URL}brokers/api/brokers/request/new`
export const EP_AFFILATE_LANDED = `${GLOBAL_BASE_URL}attributions/api/attribution/landed`
export const EP_GET_FLAVOR_LIST = `${GLOBAL_BASE_URL}flavors/api/flavors/light/secure`
export const EP_GET_LOD = `${GLOBAL_BASE_URL}api/broker/{{ID}}/lod`
export const EP_GET_LOGOUT_FLAVOR_LIST = `${GLOBAL_BASE_URL}flavors/api/flavors/detect/light`
export const EP_RISK_WARNING_STEP = `${GLOBAL_BASE_URL}customers/api/customer/broker/{{ID}}/risk/warning`

// Unmilit payment
export const GET_PAYMENT_TYPE = `${GLOBAL_BASE_URL}payments/api/customer/membershipPlan/preferredPsp`
export const UNLIMIT_NEW_PAYMENT = `${GLOBAL_BASE_URL}payments/api/unlimit/payments`

//
export const OTHER_BROKERS_LIST = `${GLOBAL_BASE_URL}brokers/api/brokerPlatform/others`










